import {combine} from 'effector';
import {createGate} from 'effector-react';

import {createNkAppeal, fetchAppealThemes} from 'api';
import {rootDomain} from 'core/rootDomain';
import {AppealTheme, NkAppealCreateRequest} from 'types';

const domain = rootDomain.createDomain('complaintCreateDomain');

export const Gate = createGate('ComplaintCreateGate');

export const createAppealFx = domain.createEffect({
    name: 'createNkAppealFx',
    handler: createNkAppeal,
});

export const createRequested = domain.createEvent<NkAppealCreateRequest>();
export const fetchThemesFx = domain.createEffect({
    name: 'fetchComplaintCreateThemesFx',
    handler: fetchAppealThemes,
});

export const themes$ = domain.createStore<AppealTheme[]>([]);

export const createState$ = combine({
    themes: themes$,
    isSubmitting: createAppealFx.pending,
    isThemesLoading: fetchThemesFx.pending,
});
